import { useToastContext } from './ToastProvider'

export const useToast = () => {
  const { showToast } = useToastContext()

  return {
    success: (message: string) => showToast(message, 'success'),
    error: (message: string) => showToast(message, 'error'),
    info: (message: string) => showToast(message, 'info'),
  }
}

export default useToast
